"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseRolEchainCalculator = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const MAX_CACHE_SIZE = 5;
class BaseRolEchainCalculator {
    constructor() {
        this.effectivePartData = new Map();
    }
    calcEffectivePartData(rolEchain) {
        let effectivePartData = this.effectivePartData.get(rolEchain);
        if (effectivePartData)
            return effectivePartData;
        effectivePartData = this.concreteCalcEffectivePartData(rolEchain);
        if (this.effectivePartData.size >= MAX_CACHE_SIZE) {
            this.effectivePartData.clear();
        }
        this.effectivePartData.set(rolEchain, effectivePartData);
        return effectivePartData;
    }
    calcLaengeWithAEs(rolEchain, aes) {
        const aeLength = aes.getCumulatedLength();
        return echain_shared_quantities_1.Length.mm(this.calcLaenge(rolEchain).mm + aeLength.mm);
    }
    calcLaengeWithAELength(rolEchain, aeLength) {
        return echain_shared_quantities_1.Length.mm(this.calcLaenge(rolEchain).mm + aeLength.mm);
    }
    calcTotalNumLinks(rolEchain) {
        const numLinksByType = this.calcNumLinksByType(rolEchain);
        return Object.values(numLinksByType)
            .filter(Boolean)
            .reduce((acc, val) => acc + val, 0);
    }
    calcCumulatedNumLinksForPart(rolEchain, _partIdentifier) {
        const numRolLinks = 0;
        const numStandardLinks = 0;
        const numAdapterLinks = 0;
        const numModifiedLinks = 0;
        const numAutoglideLinks = 0;
        return { numRolLinks, numStandardLinks, numAdapterLinks, numModifiedLinks, numAutoglideLinks };
    }
}
exports.BaseRolEchainCalculator = BaseRolEchainCalculator;
BaseRolEchainCalculator.className = 'RolEchainCalculator';
//# sourceMappingURL=BaseRolEchainCalculator.js.map